import type { MouseEvent } from "react";

import { ChevronDownIcon, type LucideIconData } from "@lucide/icons";

import { cx, styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";

import { AccordionTitleIcon, StyledAccordionTitle } from "./Accordion.styles";
import type { AccordionTitleProps } from "./Accordion.types";
import { useAccordionContext } from "./AccordionContext";

const AccordionTitleComponent = (props: AccordionTitleProps) => {
  const {
    active: activeProp,
    children,
    className,
    content,
    icon,
    index,
    tabIndex,
    onKeyDown,
    style,
    onClick,
  } = props;

  const ctx = useAccordionContext();
  const active =
    activeProp !== undefined
      ? activeProp
      : (ctx?.isIndexActive(index) ?? false);

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    const data: AccordionTitleProps = { ...props, active };
    onClick?.(event, data);
    ctx?.handleTitleClick(event, data);
  };

  const classes = cx(active && "is-active", className);
  const resolvedIcon: LucideIconData | null =
    icon === null || icon === false
      ? null
      : icon && typeof icon === "object" && "node" in icon
        ? (icon as LucideIconData)
        : ChevronDownIcon;

  return (
    <StyledAccordionTitle
      className={classes}
      style={style}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
      onClick={handleClick}
    >
      {resolvedIcon ? <AccordionTitleIcon icon={resolvedIcon} /> : null}
      {children ?? content}
    </StyledAccordionTitle>
  );
};

export const AccordionTitle = styled(AccordionTitleComponent)``;
